<div class="grid-container margin-top" role="form" [formGroup]="editForm">
  <div class="grid-x margin-top">
    <div class="cell small-12 medium-4">
      @if (fieldUnderEdit != 'status') {
        <div class="checkbox">
          <input class="show-for-sr" id="activeSwitchDisabled" type="checkbox" disabled [checked]="org.isActive">
          <label class="bold" for="activeSwitchDisabled">
            Organization is Active: <span aria-hidden="true" class="checkbox-box">
            <span aria-hidden="true" class="checkbox-check">&#x2714;</span>
          </span>
        </label>
      </div>
      <span class="bold">Status:</span>
      <span style="padding-left: 5px;">
        @if (loadingStatuses === false) {
          {{ organizationStatus }}
        } @else {
          <text-loader [run]="loadingStatuses" [interval]="3000" [tickType]="'.'" [text]="'Loading Status Definitions'"></text-loader>
        }
      </span>
      <button (click)="editField('status')" class="button editButton">
        <svg-icon icon="icon-pencil" class="small black" id="editStatus" aria-describedby="editStatusIcon"></svg-icon>
      </button>
      <span class="show-for-sr" id="editStatusIcon">Edit Organization Status</span>
    } @else {
      <div class="checkbox">
        <input class="show-for-sr" id="activeSwitch" type="checkbox" formControlName="isActive" >
        <label class="bold" for="activeSwitch">
          Organization is Active: <span aria-hidden="true" class="checkbox-box">
          <span aria-hidden="true" class="checkbox-check">&#x2714;</span>
        </span>
      </label>
    </div>
    <span class="bold">Status:</span>
    <span style="padding-left: 5px;">
      @if (loadingStatuses === false) {
        <select formControlName="status" id="status" class="active-select" (ngModelChange)="statusChanged($event)">
          @for (status of statusValues; track status) {
            <option [value]="status.Code">{{status.Definition}}</option>
          }
        </select>
      } @else {
        <text-loader [run]="loadingStatuses" [interval]="3000" [tickType]="'.'" [text]="'Loading Status Definitions'"></text-loader>
      }
      <button id="updateStatus" aria-describedby="updateStatusButton" class="button  editButton" (click)="update('status')">
        <svg-icon icon="icon-save" class="small black" id="updateStatusIcon"></svg-icon>
      </button>
      <span class="show-for-sr" id="updateStatusButton">Update Company Status</span>
    </span>
    <br />
    @if (editForm?.get('isActive')?.dirty || editForm?.get('status')?.dirty) {
      <small class="red">
        When changing the Active state, also change Company Status. <br />
        When changing the Company Status, also change Active state.
      </small>
    }
  }

</div>
<div class="cell small-12 medium-4">
  <label class="bold">Owner Number:</label> {{ org.id }}
</div>
<div class="cell small-12 medium-4">
  <label class="bold">Legacy Owner Number:</label> {{ org.historicalOwnerNumber }}
</div>
</div>
<div class="grid-x margin-top">
  <div class="cell small-12 medium-4">
    <label class="bold">Registered with RICS:</label> {{ getBooleanToYesOrNo(org.hasRegistered) }}
  </div>
  <div class="cell small-12 medium-4">
    <div class="subcolumn">
      <div class="subrow">
        <div class="bold sublabel">
          Legacy Approved Date:
        </div>
        <div class="data">
          {{ org?.dateApproved | date: 'MM/dd/yyyy':'+0000' }}
        </div>
      </div>
      <div class="subrow">
        <div class="bold sublabel">
          RICS Organization Created Date:
        </div>
        <div class="data">
          {{ ricsCreationDate | date: 'MM/dd/yyyy':'+0000' }}
        </div>
      </div>
      <div class="subrow">
        <div class="bold sublabel">
          Legacy Cancelled Date:
        </div>
        <div class="data">
          {{ org?.cancellationDate | date: 'MM/dd/yyyy':'+0000' }}
        </div>
      </div>
      <div class="subrow">
        <div class="bold sublabel">
          RICS Organization Cancelled Date:
        </div>
        <div class="data">
          {{ ricsCancellationDate | date: 'MM/dd/yyyy':'+0000' }}
        </div>
      </div>
    </div>
  </div>
  <div class="cell small-12 medium-4">
    <div class="checkbox">
      <input class="show-for-sr no-margin-bottom vertical-align-middle" id="isWellOwner" type="checkbox" disabled [checked]="isWellOwner">
      <label class="vertical-align-middle minor-margin-right" for="isWellOwner"><span aria-hidden="true" class="checkbox-box"><span aria-hidden="true" class="checkbox-check">&#x2714;</span></span> Well Owner</label>
    </div>
    <div class="checkbox">
      <input class="show-for-sr no-margin-bottom vertical-align-middle" id="isBrineHauler" type="checkbox" disabled [checked]="isBrineHauler">
      <label class="vertical-align-middle minor-margin-right" for="isBrineHauler"><span aria-hidden="true" class="checkbox-box"><span aria-hidden="true" class="checkbox-check">&#x2714;</span></span> Brine Hauler</label>
    </div>
  </div>
</div>

<div class="grid-x margin-top">
  <div class="cell small-12 medium-4 large-4">
    @if (canStartEDiscovery) {
      <button class="button" (click)="viewEDiscovery()">View eDiscovery</button>
      }&nbsp;
    </div>
    <div class="small-6 medium-4 large-4">
      <label class="bold" [ngClass]="{ 'red': !complianceStatus }">Compliance Status:</label>
      <label [ngClass]="{ 'red': !complianceStatus }"> {{ complianceStatusText }}</label>
    </div>
    <div class="cell small-6 medium-4 large-4 text-align-left">
      <button class="button" (click)="recalculate(org.id)">Recalculate Compliance</button>
    </div>
  </div>

  <div class="grid-x margin-top">
    <div class="cell small-12 medium-4">

      <label class="bold">Contact Information:</label>

      <address-block [address]="address" [canEdit]="canEdit" [form]="editForm?.get('address')" (addressUpdated)="onAddressUpdate($event)"></address-block>
      @if (fieldUnderEdit != 'primaryPhone') {
        <div class="margin-top">
          <span class="padding-right" [ngClass]="{ 'red': editForm?.get('primaryPhone')?.invalid, 'bold': editForm?.get('primaryPhone')?.invalid }">
            Phone:@if (editForm?.get('primaryPhone')?.invalid) {
            <span>*</span>
            } {{ org.phone }}
          </span>
          <button (click)="editField('primaryPhone')" class="button editButton">
            <svg-icon icon="icon-pencil" class="small black" id="editStreet" aria-describedby="editPhoneIcon"></svg-icon>
          </button>
          <span class="show-for-sr" id="editPhoneIcon">Edit Phone Number</span>
        </div>
      } @else {
        <div class="grid-x">
          <div class="cell large-2 medium-2 small-2" >
            Phone:
          </div>
          <div class="cell large-9 medium-9 small-9 padding-right">
            <input type="text" id="primaryPhone" formControlName="primaryPhone"  placeholder="XXX-XXX-XXXX"  />
          </div>
          <div class="cell large-1 medium-1 small-1">
            <button id="updatePhone" aria-describedby="updatePhoneButton" class="button editButton" (click)="update('primaryPhone')">
              <svg-icon icon="icon-save" class="small black" id="updatePhoneIcon"></svg-icon>
            </button>
            <span class="show-for-sr" id="updatePhoneButton">Update Phone Number</span>
          </div>
        </div>
      }
      @if (fieldUnderEdit != 'fax') {
        <div>
          <span class="padding-right" [ngClass]="{ 'red': editForm?.get('fax')?.invalid, 'bold': editForm?.get('fax')?.invalid }">
            Fax:@if (editForm?.get('fax')?.invalid) {
            <span>*</span>
            } {{ org.fax }}
          </span>
          <button (click)="editField('fax')" class="button editButton">
            <svg-icon icon="icon-pencil" class="small black" id="editFax" aria-describedby="editFaxIcon"></svg-icon>
          </button>
          <span class="show-for-sr" id="editFaxIcon">Edit Fax Number</span>
        </div>
      } @else {
        <div class="grid-x">
          <div class="cell large-2 medium-2 small-2">
            Fax:
          </div>
          <div class="cell large-9 medium-9 small-9 padding-right">
            <input type="text" id="fax" formControlName="fax"  placeholder="XXX-XXX-XXXX" />
          </div>
          <div class="cell large-1 medium-1 small-1">
            <button id="updateFax" aria-describedby="updateFaxButton" class="button editButton" (click)="update('fax')">
              <svg-icon icon="icon-save" class="small black" id="updateFaxIcon"></svg-icon>
            </button>
            <span class="show-for-sr" id="updateFaxButton">Update Fax Number</span>
          </div>
        </div>
      }
      @if (fieldUnderEdit != 'emailAddress') {
        <div>
          <span class="padding-right" [ngClass]="{ 'red': editForm?.get('emailAddress')?.invalid, 'bold': editForm?.get('emailAddress')?.invalid }">
            Email:@if (editForm?.get('emailAddress')?.invalid) {
            <span>*</span>
            } {{ org.email }}
          </span>
          <button (click)="editField('emailAddress')" class="button editButton">
            <svg-icon icon="icon-pencil" class="small black" id="editEmailAddress" aria-describedby="editEmailIcon"></svg-icon>
          </button>
          <span class="show-for-sr" id="editEmailIcon">Edit Email Address</span>
        </div>
      } @else {
        <div class="grid-x">
          <div class="cell large-2 medium-2 small-2">
            Email:
          </div>
          <div class="cell large-9 medium-9 small-9 padding-right">
            <input type="text" id="emailAddress" formControlName="emailAddress" />
          </div>
          <div class="cell large-1 medium-1 small-1">
            <button id="updateEmail" aria-describedby="updateEmailButton" class="button editButton" (click)="update('emailAddress')">
              <svg-icon icon="icon-save" class="small black" id="updateEmailIcon"></svg-icon>
            </button>
            <span class="show-for-sr" id="updateEmailButton">Update Email Address</span>
          </div>
        </div>
      }

    </div>
    <div class="cell small-12 medium-4">
      <label class="bold">Primary Contact:</label>
      @if (primaryContactExists) {
        <div>
          <div>{{ (primaryContact ).displayName }}</div>
          <address-block [address]="(primaryContact).address"></address-block>
          <div class="margin-top">Phone: {{ (primaryContact).primaryPhone }}</div>
          <div>Fax: {{ (primaryContact ).fax }}</div>
          <div>Email: {{ (primaryContact ).emailAddress }}</div>
        </div>
      }
      @if (!primaryContactExists) {
        <div>No Primary Contact Provided</div>
      }
    </div>
    <div class="cell small-12 medium-4">
      <label class="bold">Emergency Point Of Contact:</label>
      @if (emergencyContactExists) {
        <div>
          <div>{{ (emergencyContact).displayName }}</div>
          <address-block [address]="(emergencyContact).address"></address-block>
          <div class="margin-top">Phone: {{ (emergencyContact).primaryPhone }}</div>
          <div>Fax: {{ (emergencyContact).fax }}</div>
          <div>Email: {{ (emergencyContact).emailAddress }}</div>
        </div>
      }
      @if (!emergencyContactExists) {
        <div>No Emergency Contact Provided</div>
      }
    </div>
    <div class="cell small-12 medium-4">
      <div class="checkbox">
        <input class="show-for-sr" type="checkbox" disabled [checked]="org.noPhone">
        <label>No Phone Number Available: <span aria-hidden="true" class="checkbox-box">
          <span aria-hidden="true" class="checkbox-check">&#x2714;</span></span>
        </label>
      </div>
      @if (org.noPhone) {
        @if (fieldUnderEdit != 'responsiblePartyPhone') {
          <div>
            <span class="padding-right" [ngClass]="{ 'red': editForm?.get('responsiblePartyPhone')?.invalid, 'bold': editForm?.get('responsiblePartyPhone')?.invalid }">
              Responsible Party Phone:@if (editForm?.get('responsiblePartyPhone')?.invalid) {
              <span>*</span>
              } {{ org.responsiblePartyPhone }}
            </span>
            <button (click)="editField('responsiblePartyPhone')" class="button editButton">
              <svg-icon icon="icon-pencil" class="small black" id="editPartyPhone" aria-describedby="editPartyPhoneIcon"></svg-icon>
            </button>
            <span class="show-for-sr" id="editPartyPhoneIcon">Edit Responsible Party Phone</span>
          </div>
        } @else {
          <div class="grid-x">
            <div class="cell large-12 medium-12 small-12">
              Responsible Party Phone Number:
            </div>
            <div class="cell large-11 medium-11 small-11 padding-right">
              <input type="text" id="responsiblePartyPhone"  placeholder="XXX-XXX-XXXX" formControlName="responsiblePartyPhone" />
            </div>
            <div class="cell large-1 medium-1 small-1">
              <button id="updateResponsiblePartyPhone" aria-describedby="updateResponsiblePartyPhoneButton" class="button editButton" (click)="update('responsiblePartyPhone')">
                <svg-icon icon="icon-save" class="small black" id="updateResponsiblePartyPhoneIcon"></svg-icon>
              </button>
              <span class="show-for-sr" id="updateResponsiblePartyPhoneButton">Update Responsible Party Phone Number</span>
            </div>
          </div>
        }
      }

    </div>
  </div>
  @if (displayAddContactButton) {
    <div>
      <button class="button margin-top no-margin-bottom" (click)="addContact()">Add Contact</button>
    </div>
  }
  @if (canInitiateCommunication) {
    <div>
      <communication-selector [org]="org"></communication-selector>
    </div>
  }
  <div class="margin-top margin-bottom">
    <h2>Organization Information</h2>
    <tabs (tabClicked)="onTabClicked($event)">
      <tab title="Contacts">
        <organization-contacts #activeContacts [organization]="org" [canEditContacts]="displayAddContactButton" [enableExternalOrgEdit]="canEdit && org.isInternal == false" (contactSelected)="onContactSelected($event)" [useLegacyContacts]="false"></organization-contacts>
      </tab>
      <tab title="Legacy Contacts">
        <organization-contacts [organization]="org" [useLegacyContacts]="true"></organization-contacts>
      </tab>
      <tab title="Calendar">
        <rics-full-calendar [organizationId]="org.id" [isActive]="calendarTabActive"></rics-full-calendar>
      </tab>
      <tab title="Documents">
        @if (org != null) {
          <on-base-organization-documents [organization]="org"></on-base-organization-documents>
        }
      </tab>
      <tab title="Wells">
        <organization-wells [organization]="org"></organization-wells>
      </tab>
      <tab title="Issued Chief's Orders">
        <organization-chiefs-orders [organization]="org">

        </organization-chiefs-orders>
      </tab>
      <tab title="Financial Assurance">
        <organization-financial-assurance [organization]="org" [(complianceDetails)]="orgCompliance" [isLoading]="complianceIsLoading" [(isRecalculating)]="isRecalculating" (recalculateEvent)="recalculate($event)"></organization-financial-assurance>
      </tab>
      <!--<tab title="Issues">
      <organization-issues [organization]="org"></organization-issues>
    </tab>
    <tab title="Compliance Reporting">
      <app-organization-compliance-reporting [organization]="org"></app-organization-compliance-reporting>
    </tab>-->
  </tabs>
</div>
</div>


<org-contact-editor-modal (contactUpdated)="updateContact($event)"></org-contact-editor-modal>